import { Divider, Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { ImageHero } from '../atoms';
import {
  BloodResultsCard,
  CortisolResultsCard,
  DNAResultsCard,
  RootineFooter,
} from '../components';
import { theme } from '../utils/theme';

export const Reports = (): JSX.Element => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid item xs={11} md={11} sx={{ mt: { md: 6 } }}>
        <ImageHero
          image="/images/rootine_product_suite.png"
          alttext="person taking vitamins"
          title="Your Reports"
          description="Fuel your body with the nutrients it craves. Rootine, trusted by elite athletes and Olympians, ensures peak performance and health. With a quick cheek swab and blood prick, uncover insights from your DNA, blood, and stress levels."
          height={isMobile ? 130 : 450}
        />
      </Grid>
      {/* <Grid item xs={12} alignItems="center" justifyContent="center">
        <ManualTesting />
      </Grid> */}
      <Grid item xs={11}>
        <Divider sx={{ mt: 6 }} />
      </Grid>
      <Grid
        container
        alignItems={isMobile ? 'center' : 'flex-start'}
        justifyContent="center"
        spacing={4}
        rowSpacing={4}
        sx={{
          px: { xs: 2, md: 10 },
          marginTop: 2,
          mb: 4,
        }}
      >
        <Grid item xs={12} md={6}>
          <DNAResultsCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <BloodResultsCard testType="vitamin" />
        </Grid>
        <Grid item xs={12} md={6}>
          <BloodResultsCard testType="mineral" />
        </Grid>
        <Grid item xs={12} md={6}>
          <CortisolResultsCard />
        </Grid>
        <Grid item xs={12}>
          <RootineFooter />
        </Grid>
      </Grid>
    </Grid>
  );
};
